'use strict';

export default function f($filter, resource) {
  'ngInject';

  return resource({
    url: function () {
      return '/trips/' + this._constructorOptions.getUserId();
    },
    comparator: function (tripA, tripB) {
      var result = 0;

      try {
        result = $filter('toDate')(tripB.createdAt) - $filter('toDate')(tripA.createdAt);
      } catch (e) {
        return;
      }

      return result;
    }
  });
}



// WEBPACK FOOTER //
// ./app/src/resources/trip.js